export const PRAISE_MAX_CORE_VALUES = 3;
export const PRAISE_MAX_FRAMEWORKS = 3;
export const DIRECT_FEEDBACK_MAX_CORE_VALUES = 3;
export const DIRECT_FEEDBACK_MAX_FRAMEWORKS = 3;

export function toCoreValueCode(name: string): string {
  return name
    .trim()
    .toLowerCase()
    .split(/\s+/)
    .map((word) => word.replace(/[^a-z]/g, ''))
    .filter(Boolean)
    .join('_');
}
